import { render, staticRenderFns } from "./goldsilverinHistory.vue?vue&type=template&id=a462e20a&scoped=true&"
import script from "./goldsilverinHistory.vue?vue&type=script&lang=js&"
export * from "./goldsilverinHistory.vue?vue&type=script&lang=js&"
import style0 from "./goldsilverinHistory.vue?vue&type=style&index=0&id=a462e20a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a462e20a",
  null
  
)

export default component.exports